import { locateProxy } from '#~/agent/index.js';
import type { OmitSyncProps } from '#~/api/types.js';
import { StudioError } from '#~/error/index.js';
import type { Device } from '@studio/models/device';
import type { ControlDevice } from '@tryiris-ai/common.protojs/agent/v1/agent';

/** @internal */
export const egress = async (
  deviceId: Device['id'],
  _defaultName: string,
  onOrOff: boolean,
  videoEnable?: boolean
): Promise<void> => {
  const proxy = locateProxy(deviceId);

  if (!proxy) {
    throw new Error('PW-79B');
  }

  const config: OmitSyncProps<Pick<ControlDevice, 'egress'>> = {
    egress: {
      ndiOutput: {
        enable: onOrOff,
        includeAudio: undefined,
        video: videoEnable,
        audio: undefined,
        sinkName: undefined,
        uptimeSeconds: undefined
      },
      recording: undefined,
      rtmp: undefined
    }
  };

  // If the user doesn't set a sink name, we'll use the default source name.
  const mutation = {
    control: {
      device: {
        [deviceId]: config
      }
    }
  };

  try {
    // @ts-ignore
    await proxy.mutate(mutation, {});
  } catch (cause) {
    console.error(cause);
    throw new StudioError('Unable to egress video.', { cause });
  }
};
